import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { IGridColProps } from '@ucheba/ui/components/Grid/types'
import { IBoxProps } from '@ucheba/ui/components/Box/types'
import { IPropAs } from '@ucheba/utils/helpers/components/prop.types'

const Block = styled.div`
  background-color: ${sv.color.gold};
  padding-top: ${sm.mathVars(sv.spacing.uxxlarge, '*', 2)};
  padding-bottom: ${sv.spacing.uxxlarge};
  position: relative;
`

const TeachersList = styled.div`
  display: flex;
  overflow-x: auto;
  align-items: stretch;
`

const TeachersListItem = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
  flex-shrink: 0;
  overflow: hidden;
`

const StyledGridCol = styled.div<StyledProps<IGridColProps | IPropAs>>`
  display: flex;
  align-items: center;
`

const StyledBox = styled.div<StyledProps<IBoxProps | IPropAs>>`
  height: 100%;
`

const AbsoluteImage = styled.img`
  position: absolute;
`

const TopImage = styled(AbsoluteImage)`
  top: -80px;
  right: 0;
  width: 240px;
  height: 160px;
`

const BottomImage = styled(AbsoluteImage)`
  bottom: -87px;
  left: 0;
  width: 240px;
  height: 167px;
`

const VideoPreviewOverlay = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`

const VideoPreviewExperienceText = styled.div``

const VideoPreviewAverageScoreText = styled.div``

export default {
  Block,
  TopImage,
  BottomImage,
  TeachersList,
  TeachersListItem,
  StyledGridCol,
  StyledBox,
  VideoPreviewOverlay,
  VideoPreviewAverageScoreText,
  VideoPreviewExperienceText,
}
